<template>
    <div class="offers" v-if="isMounted">
        <ds-filter
            :data="offers"
            :fields="filterFields"
            @resultFilter="resultFilter"
            @updateFilterFields="updateFilterFields"
        ></ds-filter>

        <ds-table ref="table" :data="offersFilter" :heads="heads" expand search>
            <template v-slot:landings="{landings}">
                <vs-chip v-tooltip.position.left="landings.landingsList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-hard-drive', 'fi-rr-hdd')"/>
                    <span>{{ landings.totalLandings }}</span>
                </vs-chip>
            </template>

            <template v-slot:language="{language}">
                <vs-chip v-tooltip.position.left="language.languagesList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-globe', 'fi-rr-globe')"/>
                    <span>{{ language.totalLanguages }}</span>
                </vs-chip>
            </template>

            <template v-slot:expand="{expand}">
                <DetailsLandings :landingsData="expand.landings"/>
            </template>
        </ds-table>
    </div>
</template>

<script>
import send from "@/utils/fetch"
import ErrorHandler from "@/utils/errorHandler"
import DetailsLandings from './DetailsLandings'

export default {
    data() {
        return {
            isMounted: false,
            dataOffers: [],
            dataOffersFilter: [],
            filterFields: [
                {name: 'modals.Choose_offer', type: 'select', label: 'name', field: 'name'},
                {name: 'modals.Choose_landing', key: 'landings', type: 'select', label: 'full_name', field: 'id', sortKey: 'value'}
            ],
            heads: [
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Landings', key: 'landings', sortKey: 'totalLandings', value: 'landings', display: true},
                {name: 'global.Languages', key: 'language', sortKey: 'totalLanguages', value: 'language', display: true}
            ]
        }
    },

    components: {
        DetailsLandings,
    },

    computed: {
        offers() {
            return this.offersList
        },

        offersFilter() {
            return this.dataOffersFilter
        }
    },

    methods: {
        resultFilter(data) {
            this.dataOffersFilter = data
        },

        updateFilterFields() {
            this.$refs.table.closeExpands()
        },

        unique(array) {
            return Array.from(new Set(array))
        },

        mutations(data) {
            return data.map(item => {
                const languages = this.unique(item.landings.map(landing => landing.language))
                const landings = this.unique(item.landings.map(land => land.name))

                item.totalLandings = landings.length
                item.totalLanguages = languages.length
                item.landingsList = landings
                item.languagesList = languages

                item.landings = item.landings.map(landing => {
                    landing.full_name = `${landing.id} - ${landing.name}`

                    return landing
                })

                return item
            })
        },

        async get() {
            try {
                const offers = await send(this.$url.offers.all, 'GET')
                    .then(response => response.data.result.offers)

                this.$nextTick(() => {
                    this.offersList = this.mutations(offers)
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        await this.get()
        this.isMounted = true
    }
}
</script>
